import { useNavigate } from "react-router-dom";
import { FaArrowLeft, FaQuestionCircle, FaCheckCircle, FaTimesCircle, FaBuilding, FaShieldAlt, FaLock, FaCoins, FaChartLine } from "react-icons/fa";
import "./ResourcesShared.css";

const State2 = () => {
    const navigate = useNavigate();

    const relatedArticles = [
        {
            title: "How to Form an LLC in Wyoming",
            description: "Step-by-step guide to forming an LLC in Wyoming.",
            link: "/resources/wyoming-llc-formation"
        },
        {
            title: "Wyoming vs. Delaware LLC",
            description: "Compare the benefits of forming an LLC in Wyoming vs. Delaware.",
            link: "/resources/wyoming-vs-delaware"
        },
        {
            title: "Wyoming Annual Report Requirements",
            description: "Learn about the annual reporting requirements for Wyoming LLCs.",
            link: "/resources/wyoming-annual-reports"
        }
    ];

    return (
        <div className="rs-container">
            <main className="rs-main-content">
                <div className="rs-container-1200">
                    <nav className="rs-breadcrumb">
                        <ol>
                            <li><a href="/help">Help Center</a></li>
                            <li><a href="/resources">Resources</a></li>
                            <li>State</li>
                        </ol>
                    </nav>

                    <article className="rs-article">
                        <header className="rs-article-header">
                            <h1 className="rs-article-title">Why Choose a Wyoming LLC?</h1>
                            <div className="rs-article-meta">
                                <span>Posted by BooksComply Team</span>
                                <span>•</span>
                                <span>Last updated August 2025</span>
                            </div>
                        </header>
                                                <div className="rs-article-content">
                                <div className="rs-intro-card">
                                    <FaBuilding className="rs-intro-icon" />
                                    <p>
                                        Wyoming is one of the most business-friendly states in the U.S., making it an excellent choice for LLCs and corporations. Whether you're a U.S. resident or a foreign entrepreneur, Wyoming offers low taxes, strong privacy protections, and minimal regulations.
                                    </p>
                                </div>

                                <section className="rs-section">
                                    <h2>Key Benefits of Incorporating in Wyoming</h2>
                                    
                                    <div className="rs-benefit-card">
                                        <div className="rs-benefit-icon">
                                            <FaCoins />
                                        </div>
                                        <div>
                                            <h3>1. No State Taxes</h3>
                                            <ul>
                                                <li>No State Corporate Tax – Unlike many other states, Wyoming does not impose corporate income tax.</li>
                                                <li>No Personal Income Tax – Business owners don't pay personal state income tax on their earnings.</li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div className="rs-benefit-card">
                                        <div className="rs-benefit-icon">
                                            <FaLock />
                                        </div>
                                        <div>
                                            <h3>2. Strong Privacy Protection</h3>
                                            <ul>
                                                <li>No Public Disclosure of Owners or Shareholders – Wyoming does not require members or shareholders to be listed publicly.</li>
                                                <li>Nominee Services Allowed – You can appoint a nominee to maintain privacy.</li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div className="rs-benefit-card">
                                        <div className="rs-benefit-icon">
                                            <FaShieldAlt />
                                        </div>
                                        <div>
                                            <h3>3. Limited Liability Protection</h3>
                                            <ul>
                                                <li>Strong Asset Protection Laws – Owners and directors are protected from business debts and lawsuits.</li>
                                                <li>Lifetime Proxy Option – Shareholders can appoint someone to vote on their behalf while remaining anonymous.</li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div className="rs-benefit-card">
                                        <div className="rs-benefit-icon">
                                            <FaChartLine />
                                        </div>
                                        <div>
                                            <h3>4. Low Cost & Simple Maintenance</h3>
                                            <ul>
                                                <li>Affordable Formation Fees – Wyoming has one of the lowest incorporation costs in the U.S.</li>
                                                <li>Fewer Compliance Requirements – No need for annual meetings or complicated filings.</li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div className="rs-benefit-card">
                                        <div className="rs-benefit-icon">
                                            <FaBuilding />
                                        </div>
                                        <div>
                                            <h3>5. Business-Friendly Environment</h3>
                                            <ul>
                                                <li>No Citizenship Requirement – Foreign entrepreneurs can incorporate and operate a business in Wyoming.</li>
                                                <li>Fast Processing Times – Business filings are processed quickly.</li>
                                                <li>Wyoming Close LLC Option – Offers additional flexibility and fewer formalities.</li>
                                            </ul>
                                        </div>
                                    </div>
                                </section>

                            </div>
                        </article>
                    </div>
                </main>
            </div>
        );
    };

export default State2;